module.exports = __webpack_public_path__ + "static/media/step2img5.bbac5af4.JPG";